/**
 * Date helpers. Bangkok is Asia/Bangkok, UTC+7, no DST.
 * We lean on that to do date arithmetic without Intl.
 */

const BANGKOK_OFFSET_MS = 7 * 60 * 60 * 1000;

/** Convert a UTC Date (or ISO string) to YYYY-MM-DD in Bangkok local time. */
export function toBangkokDate(utc: Date | string): string {
  const d = typeof utc === 'string' ? new Date(utc) : utc;
  const shifted = new Date(d.getTime() + BANGKOK_OFFSET_MS);
  return shifted.toISOString().slice(0, 10);
}

/** Today in Bangkok as YYYY-MM-DD. */
export function todayBangkok(now: Date = new Date()): string {
  return toBangkokDate(now);
}

/** Add N days to a YYYY-MM-DD Bangkok date. */
export function addDays(dateStr: string, days: number): string {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + days);
  return dt.toISOString().slice(0, 10);
}

/** Inclusive date range, ascending. */
export function dateRange(start: string, end: string): string[] {
  const out: string[] = [];
  let cur = start;
  // safety bound: 366 days
  for (let i = 0; i < 400 && cur <= end; i++) {
    out.push(cur);
    cur = addDays(cur, 1);
  }
  return out;
}

/** Difference in days (b - a). */
export function daysBetween(a: string, b: string): number {
  const [ay, am, ad] = a.split('-').map(Number);
  const [by, bm, bd] = b.split('-').map(Number);
  const da = Date.UTC(ay, am - 1, ad);
  const db = Date.UTC(by, bm - 1, bd);
  return Math.round((db - da) / (24 * 60 * 60 * 1000));
}
